import { AsyncOperationBuilder2 } from 'shared/helpers/redux-helpers';
import * as Action from './actions';

export const GetFeatureFlags = () => {
	return AsyncOperationBuilder2(Action.loadFeatureFlagsAsync, cl => cl.featureFlags_Get(), {});
};
